import styled from '@emotion/styled';
import { headerHeight } from 'common/Header';
import { Transition, TransitionGroup } from 'react-transition-group';
import { AlertServiceNotification, useNotifications } from '.';
import AlertService from './AlertService';

const Container = styled.div(({ theme }) => ({
  position: 'fixed',
  zIndex: theme.zIndex.snackbar,
  left: 0,
  right: 0,
  top: headerHeight,
}));

export default function AlertServiceContainer() {
  const notifications = useNotifications();
  // const newestNotification = notifications[0];
  return (
    <Container>
      <TransitionGroup id="alerts">
        {/* this block shows only the newest notification notification */}
        {/* {newestNotification && (
          <Transition key={newestNotification.id} timeout={300}>
            {(status) => (
              <AlertServiceNotification
                status={status}
                notification={newestNotification}
                onRemove={(id) => AlertService.remove(id)}
              />
            )}
          </Transition>
        )} */}
        {/* this block shows all notifications */}
        {notifications.filter((_, i) => i < 3).map((notif) => {
          return (
            <Transition key={notif.id} timeout={300}>
              {(status) => (
                <AlertServiceNotification
                  bottomGutter
                  status={status}
                  notification={notif}
                  onRemove={(id) => AlertService.remove(id)}
                />
              )}
            </Transition>
          );
        })}
      </TransitionGroup>
    </Container>
  );
}
